import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { Car } from 'app/models/car.model';
import { User } from 'app/models/user.model';
import { SimulationService } from 'app/services/simulation.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericMapComponent } from '../../../generic-map/generic-map.component';
import { SimulationCarFormComponent } from '../car-form/car-form.component';

@Component({
    selector: 'car-list',
    templateUrl: './car-list.component.html',
    styleUrls: ['./car-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class SimulationCarListComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    public _user: User
    private _carList: Array<Car> = [];
    private _filterText: string = '';
    
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }

    public get carList(): Array<Car> {
        return this._carList;
    }

    private _dataSource: MatTableDataSource<Car> = undefined;
    public get dataSource(): MatTableDataSource<Car> {
        return this._dataSource;
    }

    private _displayedColumns = ['id', 'plate', 'eLatitude', 'poligon', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _dialog: MatDialog,
        private _spinner: NgxSpinnerService,
        private _toastService: ToasterService,
        private _simulationService: SimulationService
    ) {
    }


    public async ngOnInit() {
        await this.getCarList();

    }
    private async getCarList(): Promise<Array<Car>> {
        try {
            this._spinner.show('loading')
            this._carList = await this._simulationService.getCars(parseInt(localStorage.getItem("CompanyID")));
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Car>(this._carList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public addCar() {
        const dialog = this._dialog.open(SimulationCarFormComponent, {
            data: new Car(),
            disableClose: false
        });
        dialog.componentInstance.operation = "create"
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail()
            this.refresh();
            dialog.close();
        });
    }
    public async onCarMap(element: Car) {
        const dialog = this._dialog.open(GenericMapComponent, {
        })
        dialog.componentInstance.latitude = parseFloat(element.eLatitude);
        dialog.componentInstance.longitude = parseFloat(element.eLongitude);
    }

    public updateCar(car) {
        const dialog = this._dialog.open(SimulationCarFormComponent, {
            data: car,
            disableClose: false
        });
        dialog.componentInstance.model = car;
        dialog.componentInstance.operation = "update"
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh()
            dialog.close();
        });
    }
    public async deleteCar(car: Car) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen aracı silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                var response = await this._simulationService.deleteCar(car);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })

        } catch (error) {
            console.warn(error);
        }
        this.refresh();
    }
    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    refresh() {
        this.getCarList();
    }
}
